<div class="banner" appSlideRight>
  <h2>Embrace Your Inner Glow</h2>
  <p>Chic, confident, and effortlessly feminine — welcome to Pink Soul.</p>

  <mat-icon
    fontSet="material-symbols-outlined"
    class="fertile animate__animated animate__zoomIn"
    inline
    >fertile</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="deceased animate__animated animate__zoomIn"
    inline
    >deceased</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="menstrual_health animate__animated animate__zoomIn"
    inline
    >menstrual_health</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="local_florist animate__animated animate__zoomIn"
    inline
    >local_florist</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="spa animate__animated animate__zoomIn"
    inline
    >spa</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="allergy animate__animated animate__zoomIn"
    inline
    >allergy</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="filter_vintage animate__animated animate__zoomIn"
    inline
    >filter_vintage</mat-icon
  >
  <mat-icon
    fontSet="material-symbols-outlined"
    class="graph_5 animate__animated animate__zoomIn"
    inline
    >graph_5</mat-icon
  >
</div>
